import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { MealPlannerFilters, MealPlannerPage } from '@/Interfaces/I_mealPlanner';

type Loader<T> = (
  filters: MealPlannerFilters,
  signal?: AbortSignal,
) => Promise<AxiosResponse<MealPlannerPage<T>>>;

export default function useMealPlannerList<T>(
  loader: Loader<T>,
  filters: MealPlannerFilters,
  revision: number,
) {
  const [data, setData] = useState<MealPlannerPage<T>>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError('');
    loader(filters, controller.signal)
      .then((response) => {
        if (!controller.signal.aborted) setData(response.data);
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          setData(undefined);
          setError('Unable to load Meal Planner data. Try refresh.');
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [loader, filters, revision]);
  return { data, loading, error };
}
